<template>
  <div class="flex gap-4 flex-col">
    <due-diligence-title class="pb-2"/>

    <p align="justify" style="line-height: 130%; margin-top: 0.49cm; margin-bottom: 0.49cm">
      <font face="Calibri, serif"> </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"> A </font>
      </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"><b>{{legalEntity.company_name}}</b></font>
      </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"
          >, inscrita no CNPJ/MF sob o nº {{legalEntity.cnpj_formmated}}, (“{{legalEntity.trading_name}}”) tem a obrigação
          legal de garantir a segurança dos dados pessoais de seus colaboradores,
          clientes, parceiros e representantes legais, doravante denominados “titulares de dados pessoais”.
        </font>
      </font>
    </p>
    <p
      align="justify"
      style="
        line-height: 130%;
        margin-top: 0.49cm;
        margin-bottom: 0.49cm;
        background: #fefefe;
      ">
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt">Para estabelecer uma relação de confiança, transparência e boa-fé com nossos parceiros, elaboramos este documento. Seu principal objetivo é avaliar e categorizar o grau de conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD) dos terceiros com quem compartilhamos dados pessoais. Por meio deste formulário, buscamos compreender as práticas de coleta, uso, armazenamento, compartilhamento e exclusão de dados pessoais que são controlados por nós e eventualmente compartilhados com terceiros (Operadores).
        </font>
      </font>
    </p>
    <p
      align="justify"
      style="
        line-height: 130%;
        margin-top: 0.49cm;
        margin-bottom: 0.49cm;
        background: #fefefe;
      ">
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt">Os parceiros abrangidos por este documento se dividem em três categorias:
        </font>
      </font>
    </p>
    <ol type="a">
      <li value="a">
        <p
          align="justify"
          style="
            line-height: 130%;
            margin-top: 0.49cm;
            margin-bottom: 0cm;
            background: #fefefe;
          "
        >
          <font face="Calibri, serif">
            <font size="3" style="font-size: 13pt"
              ><b>a. Prestadores de Serviço: </b></font>
          </font>
          <font face="Calibri, serif">
            <font size="3" style="font-size: 13pt">
              pessoas jurídicas de direito privado que nos prestam serviços;
            </font>
          </font>
        </p>
      </li>

      <li>
        <p
          align="justify"
          style="line-height: 130%; margin-bottom: 0cm; background: #fefefe">
          <font face="Calibri, serif">
            <font size="3" style="font-size: 13pt"><b>b. Fornecedores: </b></font>
          </font>
          <font face="Calibri, serif">
            <font size="3" style="font-size: 13pt">
              pessoas jurídicas de direito privado que nos fornecem tecnologia e suporte para nossas atividades empresariais;
            </font>
          </font>
        </p>
      </li>

      <li>
        <p
          align="justify"
          style="line-height: 130%; margin-bottom: 0.49cm; background: #fefefe">
          <font size="3" style="font-size: 13pt" face="Calibri, serif"><b>c. Demais terceiros:</b></font>
          <font size="3" style="font-size: 13pt" face="Calibri, serif">
            pessoas físicas ou jurídicas que mantêm uma relação jurídica conosco e nos auxiliam em nossas atividades empresariais.
          </font>
        </p>
      </li>
    </ol>

    <p align="justify" style="line-height: 100%; margin-bottom: 0cm">
      <font size="3" style="font-size: 13pt" face="Calibri, serif"><b>ORIENTAÇÕES PARA O PREENCHIMENTO DO DOCUMENTO</b></font>
    </p>
    <ol>
      <li>
        <p align="justify" style="line-height: 130%; margin-bottom: 0.49cm; background: #fefefe">
          <font size="3" style="font-size: 13pt;" face="Calibri, serif"><b>1.	Objetivo do documento: </b></font>
          <font size="3" style="font-size: 13pt;" face="Calibri, serif">
            Este documento integra o Programa de Adequação à Lei Geral de Proteção de Dados Pessoais e à Segurança da Informação da organização. Seu propósito é estabelecer regras de boas práticas para o tratamento de dados pessoais, levando em conta a natureza, escopo, finalidade, riscos e benefícios do tratamento, conforme o art. 50 da LGPD.
          </font>
        </p>
      </li>
      <li>
        <p align="justify" style="line-height: 130%; margin-bottom: 0.49cm; background: #fefefe">
          <font size="3" style="font-size: 13pt;" face="Calibri, serif"><b>2.	Preenchimento dos itens: </b></font>
          <font size="3" style="font-size: 13pt;" face="Calibri, serif">
            Para os itens que requerem avaliação de conformidade com a LGPD, o parceiro deve indicar o grau de cumprimento e, quando aplicável, fornecer justificativas detalhadas. Recomenda-se que as respostas sejam o mais completas e específicas possível, com informações que demonstrem claramente a adequação às normas.
          </font>
        </p>
      </li>
      <li>
        <p align="justify" style="line-height: 130%; margin-bottom: 0.49cm; background: #fefefe">
          <font size="3" style="font-size: 13pt;" face="Calibri, serif"><b>3.	Tempo estimado de preenchimento: </b></font>
          <font size="3" style="font-size: 13pt;" face="Calibri, serif">
            O tempo estimado para o preenchimento do formulário varia entre 20 e 45 minutos, dependendo das informações e documentos a serem inseridos.
          </font>
        </p>
      </li>
      <li>
        <p align="justify" style="line-height: 130%; margin-bottom: 0.49cm; background: #fefefe">
          <font size="3" style="font-size: 13pt;" face="Calibri, serif"><b>4.	Formato de documentos anexos: </b></font>
          <font size="3" style="font-size: 13pt;" face="Calibri, serif">
            Para os itens que exigirem comprovações documentais, todos os arquivos devem ser anexados no formato PDF/A. Esse formato garante maior confiabilidade, padronização e segurança na preservação e compartilhamento das informações, além de facilitar a integridade dos dados ao longo do tempo.
          </font>
        </p>
        <p align="justify" style="line-height: 130%; margin-bottom: 0.49cm; background: #fefefe">
          <font size="3" style="font-size: 13pt;" face="Calibri, serif">
            O campo para anexar documentos só ficará visível quando a opção que exige documentação for selecionada. Por exemplo: ao marcar “Sim” em uma pergunta que solicita comprovação, o sistema abrirá automaticamente o campo para anexar o arquivo correspondente.
          </font>
        </p>
      </li>
      <li>
        <p align="justify" style="line-height: 130%; margin-bottom: 0.49cm; background: #fefefe">
          <font size="3" style="font-size: 13pt;" face="Calibri, serif"><b>5.	Confidencialidade e segurança: </b></font>
          <font size="3" style="font-size: 13pt;" face="Calibri, serif">
            Todas as informações e documentos anexos ao Formulário de Análise de Fornecedores serão tratados sob os termos de sigilo, segurança e boa-fé previstos na relação contratual. A organização compromete-se a proteger o sigilo e a integridade de todos os dados enviados.
          </font>
        </p>
      </li>
    </ol>
    <!-- CONSIDERANDO -->
    <p align="justify" style="line-height: 150%; margin-bottom: 0cm" >
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"><b>CONSIDERANDO</b></font>
      </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt">
          a relação jurídica contratual e de boa-fé estabelecida entre as partes, cujo objeto envolve o tratamento e processamento de dados pessoais e/ou dados pessoais sensíveis, à luz da Lei Geral de Proteção de Dados Pessoais – LGPD (Lei nº 13.709/2018);
          </font>
      </font>
    </p>
    <p align="justify" style="line-height: 150%; margin-bottom: 0cm">
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"><b>CONSIDERANDO</b></font>
      </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt">
          que os agentes de tratamento (controlador e operador) devem adotar medidas de segurança, técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito (art. 46, LGPD);
          </font>
      </font>
    </p>
    <p align="justify" style="line-height: 150%; margin-bottom: 0cm">
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"><b>CONSIDERANDO</b></font>
      </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt">
          que as medidas de segurança, técnicas e administrativas, devem ser adotadas desde a fase de concepção do produto ou do serviço até a sua execução (art. 46, §2º);
          </font>
      </font>
    </p>
    <p align="justify" style="line-height: 150%; margin-bottom: 0cm">
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"><b>CONSIDERANDO</b></font>
      </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt">
          que os agentes de tratamento ou qualquer outra pessoa que intervenha em uma das fases do tratamento obrigam-se a garantir a segurança da informação e privacidade prevista na LGPD em relação aos dados pessoais, mesmo após o seu término;
          </font>
      </font>
    </p>
    <p align="justify" style="line-height: 150%; margin-bottom: 0cm">
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"><b>CONSIDERANDO</b></font>
      </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt">
          que é obrigação do controlador comunicar à autoridade nacional de proteção de dados e ao titular a ocorrência de incidentes de segurança da informação  e privacidade que possam acarretar risco ou dano relevante aos titulares (art. 48, LGPD); e
          </font>
      </font>
    </p>
    <p align="justify" style="line-height: 150%; margin-bottom: 0cm">
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt"><b>CONSIDERANDO </b></font>
      </font>
      <font face="Calibri, serif">
        <font size="3" style="font-size: 13pt">
          as ações em curso do Programa de Adequação à Lei Geral de Proteção de Dados Pessoais, a segurança da informação e privacidade em curso em nossa organização, cujo propósito é estabelecer regras de boas práticas, levando em consideração, em relação ao tratamento e aos dados, a natureza, o escopo, a finalidade e a probabilidade e a gravidade dos riscos e dos benefícios decorrentes de tratamento de dados do titular.
          </font>
      </font>
    </p>
    <p align="justify" style="line-height: 150%; margin-bottom: 0cm">
      <font size="3" style="font-size: 13pt" face="Calibri, serif">
        Com esta iniciativa, reforçamos nosso compromisso em garantir a proteção, a segurança e privacidade dos dados pessoais, conforme a legislação vigente.
      </font>
    </p>
  </div>
</template>

<script>
import DueDiligenceTitle from './DueDiligenceTitle.vue'

export default {
  props: {
    legalEntity: {
      type: Object,
      default: () => ({
        cnpj_formmated: '',
        company_name: '',
        trading_name: ''
      })
    }
  },
  components: {
    DueDiligenceTitle
  }
}
</script>

<style>
</style>
